import React, { useState } from "react";
import Swal from "sweetalert"; // Import SweetAlert

export default function ReachUs() {
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "168a1465-8167-42e7-b825-2722113f3f80");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    
    if (data.success) {
      Swal("Success!", "Message sent successfully!", "success"); // Success alert
      event.target.reset();
    } else {
      Swal("Error!", "Failed to send message.", "error"); // Error alert
    }
  };

  return (
    <div className="reachus-container">
      <div className="reachus-content">
        <h1>Contact Us</h1>
        <p>We are here to assist you! Please fill out the form below to contact us.</p>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label>Name:</label>
            <input type="text" name="name" required />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input type="email" name="email" required />
          </div>
          <div className="form-group">
            <label>Contact:</label>
            <input type="tel" name="contact" required />
          </div>
          <div className="form-group">
            <label>Address:</label>
            <input type="text" name="address" required />
          </div>
          
          <button type="submit" className="submit-btn">Submit</button>
        </form>
      </div>
    </div>
  );
}
